module.exports = __webpack_public_path__ + "static/media/pink-hells.e3adbab9.jpg";